"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./BarStepper.css");

var _styles = {
  "container": "BarStepper__container___TgOBD",
  "step": "BarStepper__step___1iKIS",
  "indicator": "BarStepper__indicator___3ntU7",
  "active": "BarStepper__active___eCQTB"
};

const styles = _bind.default.bind(_styles);

const Stepper = (0, _mobxReact.observer)(({
  className,
  steps,
  currentStep,
  dataTestId
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);

  const renderStep = (step, i) => {
    const active = i + 1 <= currentStep;
    const step_classname = (0, _bind.default)(styles('step', {
      active
    }));

    const getStepperIcon = () => {
      if (active) {
        return _react.default.createElement("div", {
          className: styles('indicator', 'active')
        });
      }

      return _react.default.createElement("div", {
        className: styles('indicator')
      });
    };

    return _react.default.createElement("div", {
      className: step_classname,
      key: `${step}-${i + 1}`
    }, getStepperIcon());
  };

  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId
  }, steps.map((step, i) => renderStep(step, i)));
});
var _default = Stepper;
exports.default = _default;